<template>
  <div class="setting">
    <!-- <CDNbreadcrumbs :items="items" /> -->

<el-breadcrumb separator="/">
  <el-breadcrumb-item :to="{ name: 'allDomain' }">{{$t('allDomain.DomainNames')}}</el-breadcrumb-item>
  <el-breadcrumb-item :to="{ name: 'subdomains', params: { id: id } }">{{ subhost }}</el-breadcrumb-item>
  <el-breadcrumb-item>{{ host}} | {{$t('product.Statistics')}}</el-breadcrumb-item>
</el-breadcrumb>

    <div class="tab-content">
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane lazy :label="$t('product.flow')" name="first">
        <StaticData
          v-if="activeName === 'first'"
          mytype="flows"
          name="host" 
          :id="this.host"
         />
    </el-tab-pane>
    <el-tab-pane lazy :label="$t('product.statuscode')" name="second">
        <StaticData
          v-if="activeName === 'second'"
          mytype="codes"
          name="host" 
          :id="this.host"
         />
    </el-tab-pane>
    <el-tab-pane lazy :label="$t('product.hitrate')" name="third">
       <StaticData
          v-if="activeName === 'third'"
          mytype="hits"
          name="host" 
          :id="this.host"
         />
    </el-tab-pane>
    <el-tab-pane lazy :label="$t('product.defense')" name="four">
         <StaticData
          v-if="activeName === 'four'"
          mytype="wafs"
          name="host" 
          :id="this.host"
         />
    </el-tab-pane>
  </el-tabs>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import { apiGetDetail } from '@/service/requestRes';
import StaticData from '@/views/products/StaticData.vue';

export default {
  components: {
    StaticData,
  },
  data() {
    return {
      id: this.$route.params.id,
      sid: this.$route.params.sid,      
      subhost: null,
      host: null,      
      activeName: 'first',
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      apiGetDetail(
          'host', this.sid
      ).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
            this.subhost = data.sub_host;
            this.host = data.host;
        } else {
          this.$message({
            message: msg,
            type: 'error',
          });
        }
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>
<style lang="scss" scoped>
.setting {
    background-color: white;
    padding: 24px;
}
  .tab-content {
    margin-top: 24px;
    ::v-deep .el-tabs__item.is-active {
       color: #2664FF;
    }
    ::v-deep .el-tabs__active-bar {
      background-color: #2664FF;
    }
  }
</style>
